import styled from 'styled-components';
import { colors } from '@/styles/GlobalStyle';

export const Container = styled.section`
  width: 100%;
  max-width: 100vw;

  display: flex;
  justify-content: center;

  background: ${({ theme }) => theme.aplicativos.pontuacao.background};
  transition: background 0.15s linear;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 1024px;

  display: flex;
  flex-direction: column;
  align-items: center;

  padding: 80px 0;

  h2 {
    font-size: 56px;
    line-height: 64px;
    max-width: 500px;
    text-align: center;

    background: -webkit-${({ theme }) => theme.aplicativos.pontuacao.title};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  > p {
    margin-top: 26px;
    max-width: 582px;
    line-height: 28px;
    text-align: center;
  }

  @media (max-width: 1088px) {
    padding: 80px 30px;
  }

  @media (max-width: 750px) {
    padding: 35px 30px;
  }

  @media (max-width: 650px) {
    h2 {
      font-size: 32px;
      line-height: 38px;
      max-width: 300px;
    }

    > p {
      margin-top: 20px;
    }
  }
`;

export const BottomWrapper = styled.div`
  margin-top: 50px;

  width: 100%;
  background: ${({ theme }) => theme.aplicativos.pontuacao.circlesBackground};

  border-radius: 10px;

  border: 1px solid ${({ theme }) => theme.aplicativos.pontuacao.border};

  box-shadow: 0px 10px 20px ${({ theme }) => theme.aplicativos.pontuacao.shadow};
  transition: box-shadow 0.15s linear;
  @media (max-width: 650px) {
    margin-top: 36px;
  }
`;

export const CirclesContainer = styled.div`
  width: 100%;
  max-width: 790px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  gap: 30px;

  padding: 60px 0;

  @media (max-width: 1088px) {
    padding: 60px 30px;
  }

  @media (max-width: 850px) {
    flex-wrap: wrap;
    max-width: 450px;
    justify-content: space-around;

    padding: 35px 30px;
  }

  @media (max-width: 500px) {
    padding: 35px 20px;
  }

  @media (max-width: 450px) {
    max-width: 200px;
  }
`;

export const BottomWrapperDisclaimer = styled.div`
  width: 100%;

  padding: 26px 0;
  margin: 0 auto;
  border-top: 1px solid ${({ theme }) => theme.aplicativos.pontuacao.border};

  > div {
    max-width: 790px;
    display: flex;
    align-items: center;
    gap: 20px;
    margin: 0 auto;

    @media (max-width: 850px) {
      flex-direction: column;
      align-items: flex-start;
    }
  }

  svg,
  g,
  path {
    color: ${({ theme }) => theme.aplicativos.pontuacao.bottomDisclaimerText};
    fill: ${({ theme }) => theme.aplicativos.pontuacao.bottomDisclaimerText};
  }
  p {
    font-size: 14px;
    line-height: 27px;
    font-weight: 500;
    color: ${({ theme }) => theme.aplicativos.pontuacao.bottomDisclaimerText};
  }

  a {
    color: ${colors.blue};
    text-decoration: underline;
    transition: filter 0.15s linear;

    :hover {
      filter: brightness(85%);
    }
  }

  @media (max-width: 1088px) {
    padding: 26px 30px;
  }

  @media (max-width: 500px) {
    padding: 26px 20px;
  }
`;
